import { useContext } from "react";
import { createContext } from "react";
import BEASTIE_NAMES_UNTYPED from "./beastie_names.json";
import { LanguageData, LocalizationExtension } from "./LanguageLoaders";

export type SupportedLanguage = "en" | "ru" | "zh-CN" | "es" | "pt-BR" | "ja";
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  "en",
  "ru",
  "zh-CN",
  "es",
  "pt-BR",
  "ja",
];
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  ru: "Русский",
  "zh-CN": "简体中文",
  es: "Español",
  "pt-BR": "Português Brasileiro",
  ja: "日本語",
};

export type LocalizationFunction = (
  key: string,
  placeholders?: Record<string, string>,
  useEnName?: boolean,
) => string;

export type LanguageExtensionData = Partial<
  Record<LocalizationExtension, { lang: SupportedLanguage; data: LanguageData }>
>;

export type LocalizationType = {
  L: LocalizationFunction;
  languages: SupportedLanguage[];
  currentLanguage: SupportedLanguage;
  anyLanguageLoaded: boolean;
  languageExtensionData: LanguageExtensionData;
  setLanguage: (lang: SupportedLanguage) => void;
  getLink: (path: string) => string;
  beastieNames: Record<string, Record<SupportedLanguage, string>>;
};

export const LocalizationContext = createContext<LocalizationType>({
  L: (key) => key,
  languages: SUPPORTED_LANGUAGES,
  currentLanguage:
    (navigator.languages.find((lang) =>
      SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage),
    ) as SupportedLanguage) ?? "en",
  anyLanguageLoaded: false,
  languageExtensionData: {},
  setLanguage: () => {},
  getLink: (path) => path,
  beastieNames: BEASTIE_NAMES_UNTYPED,
});

export default function useLocalization() {
  return useContext(LocalizationContext);
}
